import { Directive, HostBinding, OnInit, inject } from '@angular/core';
import { CustomEvents } from '@utils/events/custom-events';
import { EventContext } from '@utils/events/event-context';

@Directive({ selector: '[wctElementCountWatcher]', standalone: true, providers: [EventContext] })
export class ElementCountWatcherDirective implements OnInit {
  @HostBinding('class.no-elements')  get noElements(): boolean { return this.elementLoadError || (this.elementLoadError != undefined && this.elementsLoaded < 1) }

  private elementsLoaded: number | undefined = undefined;
  private elementLoadError: boolean = false;

  private readonly eventContext = inject(EventContext);

  ngOnInit(): void {
    this.eventContext.getEvent(CustomEvents.ElementsLoaded).subscribe(event => {
      if (this.elementsLoaded === undefined) {
        this.elementsLoaded = 0;
      }

      this.elementsLoaded += event.data.count;
    });

    this.eventContext.getEvent(CustomEvents.ElementLoadError).subscribe(() => {
      this.elementLoadError = true;
    });
  }
}
